import posthog from "posthog-js";

export const initPostHog = () => {
  const phProjectAPIKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;

  if (!phProjectAPIKey || typeof window === "undefined") {
    return;
  }

  posthog.init(phProjectAPIKey, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://eu.posthog.com",
    persistence: "cookie",
    captureRecording: false,
    loaded: (posthog) => {
      if (process.env.NODE_ENV === "development") posthog.opt_out_capturing();
    },
  });
};

export { posthog };
